<template>
  <div class="page-container">
    <PageHeader title="商户用户" show-breadcrumb />

    <SearchPanel>
      <el-input v-model.trim="query.ausShopName" placeholder="商户名称" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.ausName" placeholder="用户名" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.ausPhone" placeholder="手机号" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.ausStatus" placeholder="状态" clearable size="small">
        <el-option label="正常" :value="1" />
        <el-option label="已禁用" :value="2" />
        <el-option label="已删除" :value="3" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="商户用户列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border>
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column prop="ausShopName" label="商户名称" min-width="200" show-overflow-tooltip />
        <el-table-column prop="ausName" label="用户名" min-width="120" />
        <el-table-column prop="ausPhone" label="手机号" width="140" />
        <el-table-column prop="ausOpenid" label="OpenID" min-width="200" show-overflow-tooltip />
        <el-table-column prop="ausStatus" label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.ausStatus)" size="mini">{{ statusText(row.ausStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="180" />
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getAjefUserShopList } from '@/api/api'

export default {
  name: 'UserShopList',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      list: [],
      query: { ausShopName: '', ausName: '', ausPhone: '', ausStatus: null },
      page: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created () { this.fetchList() },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await getAjefUserShopList({ ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { ausShopName: '', ausName: '', ausPhone: '', ausStatus: null }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    statusText (v) { return v === 1 ? '正常' : v === 2 ? '已禁用' : v === 3 ? '已删除' : '未知' },
    statusTagType (v) { return v === 1 ? 'success' : v === 2 ? 'warning' : v === 3 ? 'danger' : 'info' }
  }
}
</script>
